import { z } from 'zod';

import { dailyReportsResponseSchema } from '@/schemas/reports';
import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const dailyReportsParamsSchema = z.object({
	from: z.string(),
	to: z.string(),
	moduleName: z.string().optional(),
	includeConsolidated: z.boolean().optional(),
});
export type DailyReportsParams = z.infer<typeof dailyReportsParamsSchema>;

export const dailyReportsResponse = dailyReportsResponseSchema;
export type DailyReportsResponse = z.infer<typeof dailyReportsResponse>;

export type UseDailyReports = ZodUseQuery<DailyReportsResponse, DailyReportsParams>;
